module.exports = __webpack_public_path__ + "static/media/gameDetailScreenshot2.e838e831.jpg";